
import { Navigate, useSearchParams } from 'react-router-dom';

// Redirect wrapper to preserve query params for legacy signup-existing-user route
export function LegacySignupRedirect() {
  const [searchParams] = useSearchParams();
  const redirectUrl = `/signup/continue?${searchParams.toString()}`;
  return <Navigate to={redirectUrl} replace />;
}

export function ShopifySubscriptionCompleteRedirect() {
  const [searchParams] = useSearchParams();
  const redirectSearchParams = new URLSearchParams(searchParams);
  redirectSearchParams.set('sign-up-form', '1');
  return <Navigate to={`/v2/shopify/sign-up?${redirectSearchParams.toString()}`} replace />;
}
